<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_re7"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('duizhangReview_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('duizhangReview_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="documentNumber"
          title="单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.documentNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperDeliveryFee"
          title="账期运费"
          width="200"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.shipperDeliveryFeeMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('shipperDeliveryFeeMin')"
            />
            <el-input
              v-model="listQuery.shipperDeliveryFeeMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('shipperDeliveryFeeMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payAmount"
          title="补扣金额"
          width="200"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.payAmountMin"
              type="number"
              placeholder="下限"
              clearable
              @change="isNumber4listQuery('payAmountMin')"
            />
            <el-input
              v-model="listQuery.payAmountMax"
              type="number"
              placeholder="上限"
              clearable
              @change="isNumber4listQuery('payAmountMax')"
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="billType"
          title="对账单类型"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ billTypeMap[row.billType] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.billType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v, k) in billTypeMap"
              :key="k"
              :value="k"
              :label="v"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ auditMap[row.authStatus] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v, k) in auditMap"
              :key="k"
              :value="k"
              :label="v"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authName"
          title="审核人"
          width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.authName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" fixed="right" min-width="100">
        <template v-slot="{ row }">
          <el-tooltip
            v-if="getLimit('duizhangReview_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('duizhangReview_audit_button') &&
                row.authStatus == 1 &&
                row.branchCode == branchCode &&
                (isAdmin || row.applyStatus == '0')
            "
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button type="text" @click="funcAudit(row.code, row.authStep)">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              (getLimit('duizhangReview_auditInfo_button') &&
                row.authStatus > 1) ||
                (isAdmin || row.applyStatus != '0')
            "
            class="item"
            effect="dark"
            content="审核信息"
            placement="top"
          >
            <vxe-button type="text" @click="funcAudit(row.code, -1)">
              <i class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="800"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelAuditFlag"
      title="审核"
      width="640"
      height="600"
      resize
    >
      <compAudit
        ref="auditRef"
        :process-type="processType"
        :process-api="processApi"
        @fatherAuditMethod="fatherAudit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compDetail from "./components/detail.vue";
import compAudit from "@/views/tms/review/audit.vue";
import { page4Review } from "@/api/category";
import { isNumber } from "@/utils/validate.js";
export default {
  name: "CollectionAccountCheckList",
  components: {
    compDetail,
    compAudit
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/collectionAccountCheck/exportAuditList", //导出接口
        name: "对账审核"
      },
      auditMap: { "1": "审核中", "2": "已拒绝", "3": "已通过" },
      billTypeMap: { "0": "托运人对账", "1": "上游客户对账", "3": "保费对账" },
      processType: "7",
      processApi: "ntocc-tms-api/collectionAccountCheck",
      modelAuditFlag: false,
      modelDetailFlag: false,
      loading: false,
      tableData: [],
      listQuery: {
        documentNumber: "",
        shipmentName: "",
        authStatus: "",
        billType: "",
        shipperDeliveryFeeMin: "",
        shipperDeliveryFeeMax: "",
        payAmountMin: "",
        payAmountMax: "",
        authName: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        collectionAccountionType: 1
      },
      sumObject: {},
      //机构信息
      branchList: this.$store.state.components.branchList,
      //当前登录机构code
      branchCode: this.$store.state.user.party.branchCode
    };
  },
  created() {
    this.findList();
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin = partyType == "PLAT_ADMIN";
  },
  methods: {
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        page4Review(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "audit":
          this.modelAuditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 审核方法
    funcAudit(code, step) {
      this.$refs.auditRef.getInfo(code, step);
      this.modelAuditFlag = true;
    },
    // 审核组件的父方法
    fatherAudit() {
      this.modelAuditFlag = false;
      this.findList();
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "shipperDeliveryFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "payAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
<style lang="scss" scoped></style>
